import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class EstimatedPosition implements ISerialize {
    public Meter: number;

    public Time: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Meter?: number; Time?: Date }) {
        this.Meter = values.Meter ?? 0;

        this.Time = values.Time ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return '{' + `"Meter": ${JSON.stringify(this.Meter)}` + ',' + `"Time": ${'"' + formatDateIso(this.Time) + '"'}` + '}';
    }

    /**
     * Creates an instance of EstimatedPosition from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Meter?: number; Time?: Date }): EstimatedPosition {
        return new EstimatedPosition(values);
    }

    public static _FromServerJson(json: any): EstimatedPosition {
        return new EstimatedPosition({ Meter: json.Meter, Time: json.Time instanceof Date ? json.Time : new Date(json.Time) });
    }

    /**
     * Creates an instance of EstimatedPosition from another instance of EstimatedPosition.
     * @param other The EstimatedPosition you want to clone
     * @returns A cloned EstimatedPosition
     */
    public static FromOther(other: EstimatedPosition): EstimatedPosition {
        return EstimatedPosition._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EstimatedPosition.FromOther(this);
    }

    static NAME_OF_CLASS = 'EstimatedPosition';
}
